import { AnalyticsPage as AnalyticsFeature } from '@/features/analytics';

export default function AnalyticsPage() {
  return <AnalyticsFeature />;
}
